{
  "schema": 1,
  "venues": {
    "key": "venues/f13cb857b91e5e6137ddd3ed1ba73b86ef402b8b59be4418ea3711a1aa6e827b.json",
    "bytes": 130147,
    "sha256": "f13cb857b91e5e6137ddd3ed1ba73b86ef402b8b59be4418ea3711a1aa6e827b"
  },
  "basemaps": [
    {
      "key": "basemaps/c07767e21b2a00b606d378c1e46162814a6d43373e4db22ebe79581827b6baba.pmtiles",
      "bytes": 126905328,
      "sha256": "c07767e21b2a00b606d378c1e46162814a6d43373e4db22ebe79581827b6baba",
      "bounds": [
        -74.3,
        40.45,
        -73.65,
        41.05
      ],
      "minZoom": 0,
      "maxZoom": 15,
      "source": {
        "url": "https://build.protomaps.com/20261009.pmtiles",
        "etag": "\"190c8f4c724b7b0022090857f8e62887-517\"",
        "tilesetVersion": "4.15.2"
      }
    },
    {
      "key": "basemaps/e24a5a9fde99a158b3b414f4becb76e9711508b70b403d0f7ed5c1bf2bed3615.pmtiles",
      "bytes": 126960543,
      "sha256": "e24a5a9fde99a158b3b414f4becb76e9711508b70b403d0f7ed5c1bf2bed3615",
      "bounds": [
        -74.3,
        40.45,
        -73.65,
        41.05
      ],
      "minZoom": 0,
      "maxZoom": 15,
      "source": {
        "url": "https://build.protomaps.com/20261102.pmtiles",
        "etag": "\"8af8454b083f4305138a69e3dbd40b8d-519\"",
        "tilesetVersion": "4.15.2"
      }
    }
  ]
}
